<template>
	<div class="work-section">
		<div class="work-section__section work-section__section--1">
			<h2 class="work-section__title">ADD USER</h2>
			<div class="work-section__content work-section__content--1">
				<div class="users-page">
					<AddUserFrom></AddUserFrom>
				</div>
			</div>
		</div>

		<div class="work-section__section work-section__section--2">
			<h2 class="work-section__title">USERS LIST</h2>
			<div class="work-section__content work-section__content--2">
				<div class="users-page">
					<UserTable></UserTable>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import AddUserFrom from "../components/user/AddUserFrom.vue";
import UserTable from "../components/user/UsersTable.vue";

export default Vue.extend({
	name: "Users",
	components: {
		AddUserFrom,
		UserTable
	}
});
</script>

<style lang="scss" scoped>
.work-section {
	padding: 0 20px;
	display: flex;
	justify-content: space-around;
	align-items: flex-start;

	&__section {
		border: $border-color 1px solid;
		border-radius: 5px;
		margin-top: 50px;
		width: 100%;

		&--1 {
			width: 450px;
		}

		&--2 {
			width: 600px;
		}
	}

	&__title {
		border-bottom: $border-color 1px solid;
		background-color: $color7;
		text-align: center;
		font-weight: 600;
		line-height: 27px;
		font-size: 16px;
		padding: 5px 0;
	}

	&__content {
		padding: 20px 0;

		&--2 {
			padding: 25px;
		}

		&--scroll {
			padding-left: 10px;
			height: 500px;
		}
	}
}
</style>